import React, { useRef } from "react";
import { useReduxState } from "../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../configuration/reduxStoreConfig";
import ServiceProvider from "../../configuration/ServiceProvider";
import { Label } from "../../../explorer/types";
import useLanguages from "../../../explorer/hooks/useLanguages";
import { defaultLanguage } from "../../configuration/defaultSettings";
import { AppInfo } from "../../../explorer/types/System/AppInfo";

export const AppSystemProvider: React.FC<any> = (
  props: React.PropsWithChildren<any>
) => {
  const initialized = useRef<boolean>(false);
  const [appInfo, setAppInfo] = useReduxState<AppInfo>(reduxStoreConfig.systemAppInfo);
  const [labels, setLabels] = useReduxState<Label[]>(
    reduxStoreConfig.systemLabels
  );
  const currentLanguage = useLanguages().currentLanguage;

  const loadLabels = () => {
    ServiceProvider.System.getLabels(currentLanguage ?? defaultLanguage)
      .then((result) => setLabels(result))
      .catch((e) => console.log(e));
  };

  const loadAppInfo = () => {
    ServiceProvider.System.getAppInfo()
      .then((result) => {
        result.appContexts = result.appContexts?.map((a) => {
          a.code = a.code.toLowerCase();
          a.brands = a.brands.map((b) => {
            b.code = b.code?.toLocaleLowerCase();
            return b;
          });
          return a;
        });

        setAppInfo(result);
      })
      .catch((e) => console.log(e));
  };

  React.useEffect(() => {
    // useEffect viene chiamato due volte a causa di <React.StrictMode>
    if (!initialized.current) {
      if (!appInfo || !appInfo.appContexts || appInfo.appContexts.length === 0 ) {
        loadAppInfo();
      }
      // setto a true per evitare di chiamare nuovamente loadAppInfo
      initialized.current = true;
    }
  }, []);

  React.useEffect(() => {
    if (currentLanguage) {
      loadLabels();
    }
  }, [currentLanguage]);

  if (initialized.current) {
    return <>{props.children}</>;
  } else {
    return <></>;
  }
  
};
